import { appsettings } from '../../core';
import { IResponse } from '../model';
import ArraysService from './services/arrays';
import CnetService from './services/cnet';
import DateService from './services/date';
import FormService from './services/formservice';
import IndexedDBService, { Stores } from './services/indexedDB';
import NumberService from './services/number';
import ObjectService from './services/object';
import SessionService from './services/session';
import UrlService from './services/url';

class CommonService {
  private _cnet : CnetService | undefined;
  cnet = () => this._cnet = this._cnet ?? new CnetService((appsettings as any)[window.app_enviroment ?? 'production'].cnet.url);
  object: ObjectService = new ObjectService();
  url: UrlService = new UrlService();
  session: SessionService = new SessionService();
  array: ArraysService = new ArraysService();
  date: DateService = new DateService();
  number: NumberService = new NumberService();
  indexedDB: IndexedDBService = new IndexedDBService();

  form = <T>(getEntity?: () => () => IResponse<T>) => new FormService<T>(getEntity && getEntity());
}

const Common = new CommonService();
export default Common;
export { FormService, Stores };